import { render, staticRenderFns } from "./index.vue?vue&type=template&id=88716062"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88716062')) {
      api.createRecord('88716062', component.options)
    } else {
      api.reload('88716062', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=88716062", function () {
      api.rerender('88716062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distributor/edit/index.vue"
export default component.exports